import "./Topbar.css";
import { useContext, useState } from "react";
import arrow from "../../../../assets/arrow-down.png";
import profile from "../../../../assets/profile.png";
import menu from "../../../../assets/menu.png";
import { UserContext } from "../../../context/UserContext";
const Topbar = ({ heading }) => {
 const { toggleNavDisplay, user, logOut } = useContext(UserContext);
 const [showDropdown, setShowDropdown] = useState(false);
 return (
  <div className="topbar">
   <div className="content desktop">
    <div></div>
    <p>{heading}</p>
    <div
     className="profile-container"
     onClick={() => setShowDropdown(!showDropdown)}
    >
     <div className="img-container"></div>
     {user.firstName ? <p>{user.firstName}</p> : "John Doe"}
     <img height="15px" width="15px" src={arrow} alt="arrow" />
    </div>
    <div
     className={
      showDropdown ? "logout-btn-container logout-show" : "logout-btn-container"
     }
    >
     <div className="item">Profile</div>
     <div className="item">Settings</div>
     <div className="item" onClick={logOut}>
      Logout
     </div>
    </div>
   </div>

   <div className="content mobile">
    <div className="toggler" onClick={toggleNavDisplay}>
     <img src={menu} alt="menu" />
    </div>
    <div>
     <p>{heading}</p>
    </div>
    <div>
     <img src={profile} alt="profile" />
    </div>
   </div>
  </div>
 );
};

export default Topbar;
